import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import AppHeader from '../components/AppHeader';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { apiError } from '../lib/roadmap';

export default function QuoteConfirmation() {
  const { requestId } = useParams();
  const { user } = useAuth();
  const userId = user?.id;
  const [inquiry, setInquiry] = useState(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!userId) return;
    const controller = new AbortController();
    setInquiry(null); setError('');
    api.get(`/quote-requests/${requestId}`, { signal: controller.signal }).then(({ data }) => { if (!controller.signal.aborted) setInquiry(data); })
      .catch(e => { if (!controller.signal.aborted) setError(apiError(e, 'Your inquiry could not be loaded. Please try again.')); });
    return () => controller.abort();
  }, [userId, requestId, attempt]);
  return <div className="min-h-screen bg-white"><AppHeader /><main className="max-w-3xl mx-auto px-6 py-16">
    {error ? <div role="alert" className="text-red-700">{error}<button className="ml-3 underline" onClick={() => setAttempt(a => a + 1)}>Try again</button></div> : !inquiry ? <p role="status">Loading your inquiry…</p> : <section className="border border-zinc-200 p-8 md:p-12 text-center">
      <CheckCircle2 className="w-12 h-12 text-green-600 mx-auto" aria-hidden="true" />
      <h1 className="font-display text-3xl font-bold mt-6">Thank you for your inquiry</h1>
      <p className="mt-4 text-zinc-600 leading-relaxed">We will start working on your proposal and revert with the final proposal within <strong>10 business days</strong>.</p>
      <div className="mt-8 py-6 border-y border-zinc-200 text-sm space-y-3"><p><strong>Selected work: </strong>{inquiry.snapshot.package.title}</p><p><strong>Email: </strong>{inquiry.email}</p><p><strong>Mobile: </strong>{inquiry.mobile}</p><p className="text-xs text-zinc-500 break-all">Inquiry reference: {inquiry.id}</p></div>
      {inquiry.requirements && <div className="mt-5 text-left"><h2 className="text-sm font-semibold">Your additional requirements</h2><p className="whitespace-pre-wrap break-words text-sm text-zinc-600 mt-2">{inquiry.requirements}</p></div>}
      <div className="mt-8 flex flex-wrap justify-center gap-3"><Link className="bg-[#002FA7] px-5 py-3 text-sm text-white" to={`/reports/${inquiry.assessment_id}/next-steps`}>Back to Next Steps</Link><Link className="border border-zinc-300 px-5 py-3 text-sm" to={`/reports/${inquiry.assessment_id}`}>View Detailed Report</Link></div>
      <Link className="block mt-5 text-xs text-zinc-500 underline" to="/history">Back to assessments</Link>
    </section>}
  </main></div>;
}
